import React from "react";
import { IconBase, type IconProps } from "./IconBase";
import menuSVG from "images/icons/menu.svg";

export const MenuIcon = (props: IconProps) => {
  return <IconBase {...props} href={menuSVG} />;
};
